/* global google */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { IonPage, IonContent } from '@ionic/react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, DirectionsRenderer, InfoWindow } from 'react-google-maps';
import _ from 'lodash';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { detail as getDetail } from '../../../../actions/order';
import { getDetail as getTrip } from '../../../../actions/trip';
import left from '../../../../assets/new-icons/left.svg';
import noavatar from '../../../../assets/no-avatar.png';
import originmarker from '../../../../assets/new-icons/origin-orange.svg';
import destinationmarker from '../../../../assets/new-icons/dest-blue.svg';
import truckmarker from '../../../../assets/new-icons/truck_top.svg';
// import './OrderDetailScreen.scss';

const defaultOptions = {
  zoomControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
};

const directionsOptions = {
  polylineOptions: {
    strokeColor: '#008c98',
    strokeWeight: 4,
  },
  preserveViewPort: true,
  suppressMarkers: true,
};

const markerInfoWindowOptions = {
  disableAutoPan: true,
};

const OrderMap = withScriptjs(withGoogleMap(({
  position,
  origin,
  destination,
  directions,
  isMarkerInfoOpen,
  isNoGps,
  markerInfoContent,
  onTruckMarkerMouseOver,
  onTruckMarkerMouseOut,
  onTruckMarkerClick,
  onMarkerInfoClose,
}) =>
  <GoogleMap
    defaultZoom={10}
    clickableIcons={false}
    defaultOptions={defaultOptions}
    defaultCenter={position}
  >
    {_.get(position, 'lat') && _.get(position, 'lng') &&
      <Marker
        position={position}
        icon={truckmarker}
        onMouseOver={onTruckMarkerMouseOver}
        onMouseOut={onTruckMarkerMouseOut}
        onClick={onTruckMarkerClick}
      >
        {isMarkerInfoOpen && !isNoGps &&
          <InfoWindow
            onCloseClick={onMarkerInfoClose}
            options={markerInfoWindowOptions}
          >
            {markerInfoContent}
          </InfoWindow>
        }
      </Marker>
    }
    {origin.lat && origin.lng &&
      <Marker
        position={origin}
        icon={{
          url: originmarker,
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(5, 10),
        }}
      />
    }
    {destination.lat && destination.lng &&
      <Marker
        position={destination}
        icon={{
          url: destinationmarker,
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(5, 10),
        }}
      />
    }
    {directions.status === 'OK' &&
      <DirectionsRenderer
        directions={directions}
        options={directionsOptions}
      />
    }
  </GoogleMap>
));

const OrderDetailTrack = (props) => {
  const { data } = props;
  const [id, setID] = useState(props.match.params.id);
  const [idtrip, setIDTrip] = useState(props.match.params.idtrip);
  const [position, setPosition] = useState(null);
  const [origin, setOrigin] = useState({});
  const [destination, setDestination] = useState({});
  const [directions, setDirections] = useState({});
  const [isNoGps, setIsNoGps] = useState(false);
  const [isMarkerInfoOpen, setIsMarkerInfoOpen] = useState(false);
  const [latestGps, setLatestGps] = useState(null);
  const isMarkerInfoPinned = useRef(false);

  if (id !== props.match.params.id) {
    setID(props.match.params.id);
  };

  if (idtrip !== props.match.params.idtrip) {
    setIDTrip(props.match.params.idtrip);
  };

  useEffect(() => {
    props.getDetail(id).then(function (result) {
      let res = result.payload.data;
      if (res.id) {
        initMap(res);
      };
    });
  }, [id]);

  useEffect(() => {
    props.getTrip(idtrip).then(function (result) {
      let location = _.get(result, 'payload.data.latest_location', null);
      
      if (location) {
        setIsNoGps(false);
        let latest_time = null;
        let latest_position = null;
        let latest_loc_obj = null;
        _.each(location, (loc) => {
          let time = loc.time ? moment(loc.time) : null;
          if (time) {
            if (!latest_time || moment(latest_time).isBefore(time)) {
              latest_time = time;
              latest_position = {
                lat: loc.latitude,
                lng: loc.longitude,
              };
              latest_loc_obj = loc;
            }
          }
        });
  
        setPosition(latest_position);
        setLatestGps(latest_loc_obj);
      } else {
        setPosition(null);
        setLatestGps(null);
        setIsNoGps(true);
        setIsMarkerInfoOpen(false);
        isMarkerInfoPinned.current = false;
      }
    });
  }, [idtrip]);

  // useEffect(() => {
  //   if (origin && destination) {
  //     let data = {
  //       // waypoints: [
  //       //   { location: new google.maps.LatLng(position.lat, position.lng) }
  //       // ],
  //       destination,
  //     }
      
  //     if (position) {
  //       data.origin = position
  //     } else {
  //       data.origin = origin
  //     }

  //     createRoute(data)
  //   }
  // }, [position, origin, destination])

  const goBack = () => {
    // props.history.goBack();
    props.history.push('/distributor/inbound/detail/' + id);
  };

  const initMap = (res) => {
    const directionsService = new google.maps.DirectionsService();

    let ori = {
      lat: parseFloat(_.get(res, 'origin.latitude', 0)),
      lng: parseFloat(_.get(res, 'origin.longitude', 0))
    }
    setOrigin(ori);

    let dest = {
      lat: parseFloat(_.get(res, 'destination.latitude', 0)),
      lng: parseFloat(_.get(res, 'destination.longitude', 0))
    }
    setDestination(dest);

    directionsService.route(
      {
        origin: ori,
        destination: dest,
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          setDirections(result);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }


  // const createRoute = (data) => {
  //   const directionsService = new google.maps.DirectionsService();
  //   directionsService.route(
  //     data,
  //     (result, status) => {
  //       if (status === google.maps.DirectionsStatus.OK) {
  //         setDirections(result);
  //       } else {
  //         console.error(`error fetching directions ${result}`);
  //       }
  //     }
  //   );
  // }

  const google_api_key = process.env.REACT_APP_GOOGLE_API_KEY;
  const google_map_url = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=drawing&key=${google_api_key}`;

  const closeMarkerInfo = () => {
    setIsMarkerInfoOpen(false);
    isMarkerInfoPinned.current = false;
  };

  const markerInfoContent = (
    <div style={{
      position: 'relative',
      width: '280px',
      backgroundColor: 'rgba(48, 48, 48, 0.88)',
      borderRadius: '8px',
      padding: '16px 40px 16px 16px',
      color: '#ffffff',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.25)',
      fontFamily: "'Inter', 'Roboto', 'Outfit', sans-serif",
      fontSize: '12px',
      lineHeight: '1.6',
    }}>
      <button
        type="button"
        aria-label="Close marker detail"
        onClick={closeMarkerInfo}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          width: '24px',
          height: '24px',
          border: 0,
          borderRadius: '4px',
          backgroundColor: 'transparent',
          color: '#ffffff',
          cursor: 'pointer',
          fontSize: '18px',
          lineHeight: '24px',
          padding: 0,
        }}
      >
        x
      </button>

      <div style={{ display: 'flex', marginBottom: '10px' }}>
        <span style={{
          backgroundColor: '#FFEBEB',
          color: '#F23D3D',
          fontSize: '10px',
          fontWeight: 'bold',
          padding: '4px 8px',
          borderRadius: '4px',
          textTransform: 'uppercase',
          display: 'inline-block',
        }}>
          ON TRIP
        </span>
      </div>

      <div style={{
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '8px',
      }}>
        {_.get(data, 'trip.vehicle.license_plate') || '-'}
      </div>

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        Shipment: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.get(data, 'shipment_number') || '-'}</strong>
      </div>

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        Status: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.get(data, 'status.name') || '-'}</strong>
      </div>

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        Origin: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.get(data, 'origin.name') || _.get(data, 'origin_contact_name') || '-'}</strong>
      </div>

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        Destination: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.get(data, 'destination.name') || _.get(data, 'destination_contact_name') || '-'}</strong>
      </div>

      <div style={{ marginBottom: '2px', color: '#E0E0E0' }}>
        Current Location: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.get(latestGps, 'addr') || '-'}</strong>
      </div>

      {_.get(position, 'lat') && _.get(position, 'lng') && (
        <div style={{ marginBottom: '6px', color: '#FFF', fontWeight: 'bold' }}>
          {position.lat} {position.lng}
        </div>
      )}

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        Speed: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.isNil(_.get(latestGps, 'speed')) ? '-' : _.get(latestGps, 'speed')}</strong>
      </div>

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        ACC: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.isNil(_.get(latestGps, 'acc')) ? '-' : (_.get(latestGps, 'acc') ? 'ON' : 'OFF')}</strong>
      </div>

      <div style={{ marginBottom: '4px', color: '#E0E0E0' }}>
        ETA: <strong style={{ color: '#FFF', fontWeight: '500' }}>{_.get(data, 'expected_arrival') ? moment(data.expected_arrival).format('YYYY-MM-DD HH:mm') : '-'}</strong>
      </div>
    </div>
  );

  return (
    <IonPage className="order-detail">
      <IonContent>
        {isNoGps &&
          <div
            className="order-detail-card-container"
            style={{
              bottom: 'auto',
              top: '40%',
              textAlign: 'center',
            }}
          >
            <div
              className="order-detail-card"
              style={{
                width: '50%',
                margin: 'auto',
              }}
            >
              Tidak ada informasi GPS dari driver
            </div>
          </div>
        }

        <div className="back-btn" onClick={goBack}>
          <img src={left} alt=""/>
        </div>

        <div className="order-detail-card-container">
          <div className="order-detail-card">
            {_.get(data, 'trip.driver', false) &&
              <div style={{display: 'inline-flex'}}>
                <img src={_.isNil(data.trip.driver.image_url) ? noavatar : data.trip.driver.image_url} alt=''/>
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '5px'}}>{data.trip.driver.name || '-'}</div>
                  <div>{data.trip.driver.phone_number || '-'}</div>
                </div>
              </div>
            }
            <span className="order-status">{_.get(data, 'status.name', '')}</span>
            <div style={{display:'inline-flex', fontSize: '12px', marginTop: '14px', width: '100%'}}>
              <div style={{marginRight: '20px'}}>
                <div className="order-card-title">Distance</div>
                <div>{data.distance || '0'} Km</div>
              </div>
              <div>
                <div className="order-card-title">Shipper</div>
                <div>{_.get(data, 'company_shipper.name', '-') || '-'}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="order-track-map" style={{
          height: '100%',
          width: '100%',
          filter: isNoGps ? 'brightness(0.5)' : 'none'
        }}>
          <OrderMap
            isMarkerShown
            googleMapURL={google_map_url}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            position={position}
            origin={origin}
            destination={destination}
            directions={directions}
            isMarkerInfoOpen={isMarkerInfoOpen}
            isNoGps={isNoGps}
            markerInfoContent={markerInfoContent}
            onTruckMarkerMouseOver={() => setIsMarkerInfoOpen(true)}
            onTruckMarkerMouseOut={() => {
              if (!isMarkerInfoPinned.current) {
                setIsMarkerInfoOpen(false);
              }
            }}
            onTruckMarkerClick={() => {
              isMarkerInfoPinned.current = true;
              setIsMarkerInfoOpen(true);
            }}
            onMarkerInfoClose={closeMarkerInfo}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = state => {
  return {
    data: state.order.detail
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    getDetail, getTrip
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailTrack);
